<template>
  <div>
    <span
      v-for="(division, index) in divisions"
      :key="division._id"
    >
      <a
        href="#"
        @click.prevent="changeDivisions"
      ><Gavel />&nbsp;{{ division.name }}</a>
      <span v-if="index < divisions.length - 1"><br></span>
    </span>
  </div>
</template>

<script>
import Gavel from 'vue-material-design-icons/Gavel.vue'

export default {
  name: 'JudgeDivisions',
  components: {
    Gavel
  },
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      divisions: []
    }
  },
  mounted () {
    this.$store
      .dispatch('admin/GET_JUDGE_DIVISIONS', { userId: this.userId })
      .then(res => {
        this.divisions = res.data.divisions
      })
  },
  methods: {
    changeDivisions () {
      this.$emit('changeDivisions')
    }
  }
}
</script>
